import { some } from "../../../../utils/some";
export var getIsSubmitButtonDisabled = function getIsSubmitButtonDisabled(inputsState) {
  return some(inputsState, function (inputState) {
    return !!inputState.error;
  });
};